/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "@/src/components/Container/Container";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import LpAdvocardMeta from "./LpAdvocardMeta";
import HowItWorksSectionContract from "@/src/components/Sections/Contract/HowItWorksSection/HowItWorksSectionContract";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "@/src/services/landingPageService";
import SpecialEnergyContractCheckin from "@/src/components/Checkin/ContractCheckin/SpecialEnergyContractCheckin";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const LpSpecialEnergyCasesAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      <LpAdvocardMeta
        title={"Professionelle Hilfe im Vertragsrecht | Legalbird"}
        description={"Professionelle Hilfe im Vertragsrecht - Schnell, einfach und sicher! Jetzt beraten lassen!"}
      />
      <LandingPageTeaser
        teaserButtonText={"Jetzt starten"}
        headline={"Advocard Energie-Hilfe: Probleme mit Ihrem Anbieter?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <SpecialEnergyContractCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
      <HowItWorksSectionContract />
      <AttorneySection subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"} />
      <CustomerFeedback />
      {!isLoggedIn && (
        <Container>
          <SpecialEnergyContractCheckin idPrefix={"bottom"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default LpSpecialEnergyCasesAdvocard;
